import { Box, Skeleton, Grid, Paper } from '@mui/material';
import { memo } from 'react';

const FormSkeleton = memo(() => {
    return (
        <Box sx={{ p: 4 }}>
            <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12} md={6}>
                    <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                </Grid>
            </Grid>

            <Box sx={{ mb: 4 }}>
                <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                    </Grid>
                </Grid>
            </Box>

            <Box>
                <Skeleton variant="text" width={250} height={32} sx={{ mb: 2 }} />
                {[1, 2].map(index => (
                    <Paper key={index} elevation={0} sx={{ p: 3, mb: 2, border: 1, borderColor: 'divider' }}>
                        <Skeleton variant="text" width={150} height={24} sx={{ mb: 2 }} />
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={3}>
                                <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                            </Grid>
                        </Grid>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
});

export default FormSkeleton;
